"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16z"
}), 'TransitEnterexit');